import React from "react";
import { Select as AntSelect, Divider, Spin } from "antd";
import { ChevronIcon } from "../assets";
import { Form } from "antd";

type OptionType = {
  id: string;
  name: string;
};

type SelectProps = {
  options: OptionType[];
  formItemProps: any;
  suffixIcon?: React.ReactNode;
  onChange?: (value: string) => void;
  dropdownRender?: React.ReactNode;
  loading?: boolean;
  placeholder?: string;
};

const Select: React.FC<SelectProps> = ({
  options,
  formItemProps,
  dropdownRender,
  onChange,
  loading,
  placeholder,
}) => {
  const props: any = {};
  if (dropdownRender) {
    props.dropdownRender = (menu: any) => {
      return (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          {dropdownRender}
        </>
      );
    };
  }

  return (
    <Form.Item {...formItemProps}>
      <AntSelect
        suffixIcon={loading ? <Spin size="small" /> : <ChevronIcon />}
        onChange={onChange}
        {...props}
        placeholder={placeholder}
        options={options.map((item) => ({ label: item.name, value: item.id }))}
      />
    </Form.Item>
  );
};

export default Select;
